module.exports = __webpack_public_path__ + "img/pr-mon.064aedc2.png";